<ng-container>
    <app-data-table [columns]="cols" [data]="equipments" [isCardView]="false" [url]="'/master/evalution/criteria/'"
        [isDeletable]="'/master/evaluation' | hasPermission: 'Delete'" [isView]="'/master/evaluation' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
        [showAddButton]="'/master/evaluation' | hasPermission: 'Add'" [showActions]="canEditSetup"
        [isEditable]="'/master/evaluation' | hasPermission: 'Edit'" [title]="title" (onAdd)="addCriteria()"
        (editEventRow)="onUpdateCriteria($event)" (onLazyLoadData)="getCriteria($event)" 
        (deleteEventRow)="showDeletePopup($event)">
    </app-data-table>
</ng-container>

<!-- Reusable Dialog for Add/Edit/View -->
<app-reusable-dialog
    [(visible)]="showDialog"
    [config]="dialogConfig"
    [initialData]="formData"
    [viewMode]="viewMode"
    (onSubmit)="onSubmitCriteria($event)"
    (onCancel)="onCancelDialog()"
    (onClose)="onCloseDialog()">
</app-reusable-dialog>

<!-- Delete Confirmation Dialog -->
<p-dialog header="Delete Criteria" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
    [maximizable]="true">
    <div class="delete-dialog mt-3">
         <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete Criteria ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteequipment()">
        </p-button>
    </div>
</p-dialog>